module.exports = __webpack_public_path__ + "static/finb2-c2cd9dfa612f55438e55fec01a87828a.jpg";